// @flow
import {
  isRequired,
  minLength,
  maxLength,
  hasDigit,
  hasLowercaseLetter,
  hasUppercaseLetter,
  hasSpecialCharacter,
  hasSpaceCharacter,
  isEmail,
} from '@clark-inc/clark-forms';

const sevenMinLength = minLength(7);
const seventyMaxLength = maxLength(70);
const needsDigit = hasDigit('password');
const needsLowercaseLetter = hasLowercaseLetter('password');
const needsUpperLetter = hasUppercaseLetter('password');
const needsSpecialCharacter = hasSpecialCharacter('password');
const needsSpaceCharacter = hasSpaceCharacter('password');

const RESET_FIELD_SET = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'input',
            inputType: 'password',
            name: 'password',
            label: 'Password',
            placeholder: 'enter a secure password',
            hasShowHideButton: true,
            hasPasswordRequirements: true,
            validate: [
              isRequired,
              sevenMinLength,
              seventyMaxLength,
              needsDigit,
              needsLowercaseLetter,
              needsUpperLetter,
              needsSpecialCharacter,
              needsSpaceCharacter,
            ],
          },
        ],
      },
    ],
  },
];

const FORGOT_FIELD_SET = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'input',
            name: 'email',
            label: 'Email',
            validate: [isRequired, isEmail],
          },
        ],
      },
    ],
  },
];

export { FORGOT_FIELD_SET, RESET_FIELD_SET };



// WEBPACK FOOTER //
// ./src/containers/password-form/fieldset.js